/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import Image from 'react-image'
import NoImage from 'assets/images/no-image.jpg'
import ThumbnailLoader from 'components/shared/loaders/thumb'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import authActions from 'actions/auth/actions'

const Favorites = ({ data, fetchFavorites }) => {
  useEffect(() => {
    fetchFavorites()
  }, [])
  // eslint-disable-next-line no-nested-ternary
  if (!data || !data.categories) {
    return <></>
  }
  if (data.favorites.length === 0) return <>Nothing to show...</>
  return data.categories.map(({ id, name }, key) => {
    const favoritesInCategory = data.favorites.filter((item) => item.category_id === id) ?? []
    return (
      <div className="my-2" key={key}>
        <p className="text-lg font-semibold px-2">{name}</p>
        <ul className="flex flex-row flex-wrap">
          {favoritesInCategory.map(({ id, title, imageSrc, imageAlt, url, capacity, prices }) => (
            <li className="dropdown w-1/2 p-2 h-64 relative" key={id}>
              <a href={url}>
                <Image
                  src={[imageSrc, NoImage]}
                  alt={imageAlt}
                  className="w-full h-full object-cover rounded"
                  loader={<ThumbnailLoader />}
                />
                <div className="absolute max-h-max left-0 bottom-0 right-0 text-white flex justify-between items-center m-2">
                  <div className="relative">
                    <p className="text-sm px-2">{prices[0]}</p>
                    <div className="flex">
                      <div className="clamp-2 text-sm font-bold pr-1 pl-2">{title}</div>
                      <p className="pl-1 text-sm w-max whitespace-no-wrap pr-2">
                        {capacity}
                      </p>
                    </div>
                    <div
                      className="absolute bottom-0 top-0 left-0 right-0"
                      style={{ backgroundImage: 'linear-gradient(white, black)', opacity: '.1' }}
                    />
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  })
}

Favorites.propTypes = {
  data: PropTypes.object,
  fetchFavorites: PropTypes.func.isRequired,
}

const mapStateToProps = ({ auth }) => ({
  data: auth.user.favoritesData,
})

const mapDispatchToProps = {
  fetchFavorites: authActions.fetchUserFavorites,
}

export default connect(mapStateToProps, mapDispatchToProps)(Favorites)
